export default {
  N01a_SDKP_DVDT_ND112020: 'N01a_SDKP_DVDT_ND112020',
  N01a_SDKP_DVDT_ND112020_Dynamic: 'N01a_SDKP_DVDT_ND112020_Dynamic',
};
